import { useHybridTheme } from '../themes/useHybridTheme';
import { componentColors } from '../themes/components';
import { type ThemeName } from '../themes/tokens';

export function useThemeColors() {
  const { theme } = useHybridTheme();
  return componentColors[theme as ThemeName];
}
